var React = require('react');

function Clipboard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M336 63h-80v1a64 64 0 0 1 64 64H64a64 64 0 0 1 64-64v-1H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V111a48 48 0 0 0-48-48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 64a64 64 0 0 0-128 0 64 64 0 0 0-64 64h256a64 64 0 0 0-64-64zm-64 24a24 24 0 1 1 24-24 23.94 23.94 0 0 1-24 24z","className":"fa-primary","key":2})]);
}

Clipboard.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Clipboard;

Clipboard.default = Clipboard;
